import Product from "./components/Product/Product";

function App() {
  return (
    <div className="App">
      <Product />
    </div>
  );
}

export default App;
